import * as angular from 'angular';

import { ComponentDefinition, ContextualField } from '../../../models';
import { IStoreService, IRecipientsHelper, IRecipientsComponentViewModel } from '../../../services';
import { IRootScope } from 'IRootScope';
import { backButtonClick, toggleEditMode } from '../../../common';
import { StoreElement, Store } from '../../../stateManagement';
import { SendMailAction } from '../../../models/triggerActions/SendMailAction';
import { IEditSendMailActionService } from '../../services.index';
import { remapMailRecipients } from '../../../models/mailing/remapMailRecipients';

class EditSendMailActionStateController implements angular.IComponentController {
    action: SendMailAction;
    formController: angular.IFormController;
    isEditMode: boolean;
    isLoading: boolean;
    mailFormController: angular.IFormController;
    properties: ContextualField[];
    recipients: IRecipientsComponentViewModel;

    private _actionGuid: string;
    private _garbages: (() => void)[];
    private _loaded: angular.IPromise<any>;
    private _origin: string;
    private _pristine: SendMailAction;

    static $inject = [
        '$rootScope',
        '$state',
        '$stateParams',
        'storeService',
        'editSendMailActionService',
        'recipientsHelper',
    ];

    constructor(
        private _$rootScope: IRootScope,
        private _$state: angular.ui.IStateService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _storeService: IStoreService,
        private _editSendMailActionService: IEditSendMailActionService,
        private _recipientsHelper: IRecipientsHelper,
    ) {
    }

    $onInit() {
        this._garbages = [];
        this.isLoading = true;
        this._actionGuid = this._$stateParams['actionGuid'];
        this._origin = this._$stateParams['origin'];
        this.properties = this._editSendMailActionService.getProperties();
        this._loaded = this._recipientsHelper
            // no need for strategy if we display all
            .loadRecipients(undefined, true)
            .then(r => this.recipients = r);


        this._garbages.push(this._storeService.register(
            store => this._loaded.then(() => this.refreshStore(store)),
            [StoreElement.Actions]
        ));

        if (!this._$rootScope.isEditMode) {
            this._$rootScope.$broadcast(toggleEditMode, true);
        }
        this.isEditMode = true;
        this._garbages.push(this._$rootScope.$on(backButtonClick, () => this.goBack()));
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    save() {
        remapMailRecipients(this.action.emailDefinition, this.action.emailDefinition.selectedChoices);
        return this._storeService.dispatchers().actions
            .updateOne(this.action);
    }

    cancel() {
        this.resetAction();
    }

    // send test email
    send() {
        this.isLoading = true;
        this._editSendMailActionService
            .send(this.action.emailDefinition)
            .finally(() => this.isLoading = false);
    }

    private goBack(): angular.IPromise<any> {
        return this._$state.go(this._origin);
    }

    private refreshStore(store: Store): void {
        const action = store.actions.dictionary[this._actionGuid] as SendMailAction;
        this._pristine = action;
        this.resetAction();
        this.isLoading = false;
    }

    private resetAction(): void {
        this.action = angular.copy(this._pristine);
        if (this.formController) {
            this.formController.$setPristine();
        }
        if (this.mailFormController) {
            this.mailFormController.$setPristine();
        }
    }
}

export const wtEditSendMailActionState: ComponentDefinition = {
    componentId: 'wtEditSendMailActionState',
    controller: EditSendMailActionStateController,
    template: require('./editSendMailActionState.component.html'),
    controllerAs: 'vm',
    bindings: {}
};